import React from 'react';
import { Button } from '../../../ui/Button';
import { PersonalInfo } from './Information/PersonalInfo';
import { PropertyPreferences } from './Information/PropertyPreferences';

interface InformationProps {
  onNext: () => void;
}

export const Information: React.FC<InformationProps> = ({ onNext }) => {
  return (
    <div className="space-y-6">
      <PersonalInfo />
      <PropertyPreferences />
      
      <div className="flex justify-end">
        <Button onClick={onNext}>
          Suivant
        </Button>
      </div>
    </div>
  );
};